export default {
  acceptTermsRequired: 'terms and conditions ஒப்புக்கொள்ளவும்',
  accountNumber: 'A/C Number',
  acknowledgedText: 'ஒப்புக்கொள்ளப்பட்டது',
  acknowledgeText: 'ஒப்புக்கொள்',
  active: 'செயலில்',
  activeBookings: 'செயலில் உள்ள முன்பதிவுகள்',
  activeBucketsText: 'செயலில் உள்ள buckets',
  activeToday: 'இன்று செயலில்',
  adminRole: 'அட்மின் — Managing Director',
  advance: 'முன்பணம்',
  advancePaid: 'முன்பணம் செலுத்தப்பட்டது',
  advancePaidLabel: 'முன்பணம்',
  agreement: 'விதிமுறைகள் & ஒப்பந்தம்',
  agreeTermsCheckbox: 'அனைத்து விதிமுறைகள் & நிபந்தனைகளையும் படித்து ஒப்புக்கொள்கிறேன்',
  alertLog: 'எச்சரிக்கை பதிவு',
  alerts: 'எச்சரிக்கைகள்',
  alertText: 'எச்சரிக்கை',
  allAlerts: 'அனைத்து எச்சரிக்கைகள்',
  allLoaded: 'அனைத்தும் ஏற்றப்பட்டது',
  allMachinesOk: 'அனைத்து இயந்திரங்களும் சரியாக இயங்குகின்றன.',
  allowedText: 'அனுமதிக்கப்பட்டது',
  allStats: 'முழு புள்ளிவிவரங்கள்',
  amount: 'தொகை',
  apiHealthTitle: 'API Health',
  apiSloAlertsTitle: 'API SLO Alerts',
  appName: 'Development Express',
  approvals: 'அனுமதிகள்',
  approveAndDispatch: 'அனுமதித்து இயந்திரம் அனுப்பு',
  approved: 'அனுமதிக்கப்பட்டது',
  assignedOperator: 'ஒதுக்கப்பட்ட ஆபரேட்டர்',
  attemptsLabel: 'முயற்சிகள்',
  attendance: 'வருகை',
  auditLogs: 'ஆடிட் பதிவுகள்',
  available: 'கிடைக்கிறது',
  availableMachinery: 'கிடைக்கும் இயந்திரங்கள்',
  availableNow: 'இப்போது கிடைக்கிறது',
  avgRating: 'சராசரி மதிப்பீடு',
  awaitingClientFeedback: 'வாடிக்கையாளர் கருத்துக்காக காத்திருக்கிறது',
  awaitingDispatch: 'அனுப்புதலுக்காக காத்திருக்கிறது',
  back: 'பின்னால்',
  backToLogin: 'உள்நுழைவுக்குத் திரும்பு',
  bank: 'வங்கி',
  bankDetailsTitle: 'வங்கி விவரங்கள்',
  baseAmount: 'அடிப்படை தொகை',
  billingWallet: 'வாலட் & பில்லிங்',
  blacklistWarning: '⛔ Blacklist எச்சரிக்கை',
  blockedRateText: 'தடுப்பு விகிதம்',
  blockedText: 'தடுக்கப்பட்டது',
  bookingConfirm: 'முன்பதிவை உறுதிப்படுத்து',
  bookingCostCalculator: 'முன்பதிவு & செலவு கணக்கிடி',
  bookingFailedGeneric: 'முன்பதிவு தோல்வி. மீண்டும் முயற்சிக்கவும்.',
  bookingHistory: 'முன்பதிவு வரலாறு',
  bookingReportTitle: 'முன்பதிவு அறிக்கை',
  bookingScheduleSummary: 'தினசரி & மாதாந்திர முன்பதிவு அட்டவணை',
  bookingsCount: '{count} முன்பதிவுகள்',
  bookingSelectMachineFirst: 'தொடர fleet-லிருந்து இயந்திரம் தேர்ந்தெடுக்கவும்.',
  bookingsScheduleHint: 'வாடிக்கையாளர்கள் முன்பதிவு செய்யும்போது தினசரி அட்டவணை இங்கே தோன்றும்.',
  bookingStepChoose: 'இயந்திரம் தேர்ந்தெடு',
  bookingStepConfirm: 'உறுதிப்படுத்தி செலுத்து',
  bookingStepCost: 'செலவு & தேதிகள்',
  bookingType: 'முன்பதிவு வகையைத் தேர்ந்தெடு',
  bookingTypeLabel: 'முன்பதிவு வகை',
  bookingTypeText: 'முன்பதிவு வகை',
  bookMachine: 'இயந்திரம் முன்பதிவு',
  bookMachineAction: 'இயந்திரம் முன்பதிவு',
  bookNow: 'இப்போதே முன்பதிவு',
  burstText: 'BURST',
  busy: 'பிஸி',
  callNow: 'இப்போது அழை',
  cancel: 'ரத்து செய்',
  cancelAction: 'ரத்து செய்',
  cancelBooking: 'முன்பதிவை ரத்து செய்',
  cancelBookingPrompt: 'முன்பதிவை ரத்து செய்யவா?',
  cancelPolicy: 'ரத்து கொள்கை',
  cancelText: 'ரத்து',
  cancelWarning: 'ரத்து செய்ய விரும்புகிறீர்களா?',
  changeLanguage: 'மொழியை மாற்று',
  changeMachine: 'இயந்திரம் மாற்று',
  changeMobileNumber: 'மொபைல் எண் மாற்று',
  chipAction: 'செயல்',
  chipActor: 'நடிகர்',
  chipEntity: 'entity',
  chipFrom: 'இருந்து',
  chipMeta: 'meta',
  chipRole: 'பாத்திரம்',
  chipTo: 'வரை',
  clearAll: 'அனைத்தையும் அழி',
  client: 'வாடிக்கையாளர்',
  clientFeedbackLabel: 'வாடிக்கையாளர் கருத்து',
  clientPortal: 'வாடிக்கையாளர் போர்ட்டல்',
  clientRatingsTitle: 'வாடிக்கையாளர் மதிப்பீடுகள் & பரிந்துரைகள்',
  clientRole: 'வாடிக்கையாளர் (contractor)',
  clients: 'வாடிக்கையாளர்கள்',
  commission: 'கமிஷன்',
  commission15: 'கமிஷன் 15%',
  commissionPaid: 'கமிஷன் செலுத்தப்பட்டது',
  commissionRate: 'மொத்த பில்லிங்கின் 15%',
  company: 'நிறுவனம்',
  companyDetailsTitle: 'நிறுவன விவரங்கள்',
  completeBookings: 'முடிந்த முன்பதிவுகள்',
  completedBookings: 'முடிந்த முன்பதிவுகள்',
  condition: 'நிலை',
  confirm: 'உறுதிப்படுத்து',
  confirmBooking: 'முன்பதிவை உறுதிப்படுத்து',
  confirmBookingAction: 'முன்பதிவை உறுதிப்படுத்து',
  confirmCancel: 'ரத்தை உறுதிப்படுத்து',
  confirmPassword: 'கடவுச்சொல் உறுதிப்படுத்து',
  confirmRetry: 'மீண்டும் முயற்சியை உறுதிப்படுத்து',
  contactCompany: 'Development Express-ஐ தொடர்பு கொள்ளுங்கள்',
  costCalculator: 'செலவு கணக்கிடி',
  crawlerNoRto: 'Crawler (RTO இல்லை)',
  currentlyDeployed: 'தற்போது பணியில்',
  customAmount: 'தனிப்பயன் தொகை (குறைந்தது ₹5,000)',
  cycles: "சுழற்சிகள்",
  dailyWorkReport: 'தினசரி வேலை அறிக்கை',
  dashboard: 'டாஷ்போர்ட்',
  date: 'தேதி',
  dayMachinesLabel: 'இயந்திரங்கள்',
  days: 'நாட்கள்',
  daysUnit: 'நாள்',
  directContactBlacklist: 'நேரடி தொடர்பு = பிளாக்லிஸ்ட்',
  directContactProhibited: 'நேரடி தொடர்புகள் கண்டிப்பாக தடை செய்யப்பட்டுள்ளன',
  directContactProhibitedText: 'நேரடி தொடர்பு கண்டிப்பாக தடை செய்யப்பட்டுள்ளது',
  dispatched: 'அனுப்பப்பட்டது',
  dlqMonitor: 'DLQ மானிட்டர்',
  docChassisPlate: 'Chassis / Serial Plate Photo (RTO RC இல்லை)',
  docEquipmentPhoto: 'Full Machine Photo (side view)',
  docIdentity: 'PAN Card / Aadhaar',
  docInsurance: 'Insurance Certificate',
  docInsuranceOptional: 'Insurance / Equipment Cover (if available)',
  docMachineInvoice: 'Machine Purchase / Invoice (dealer bill)',
  docPollution: 'Pollution Certificate (PUC)',
  docRcBook: 'RC Book (RTO Registration Certificate)',
  documents: 'ஆவணங்கள் பதிவேற்றம்',
  documentUploadTitle: 'ஆவணங்கள் பதிவேற்றம்',
  download: 'பதிவிறக்கம்',
  drawerMenu: 'மெனு',
  earnings: 'வருமானம்',
  email: 'மின்னஞ்சல் ஆதரவு',
  emailAddress: 'மின்னஞ்சல் முகவரி',
  emailAddressLabel: 'மின்னஞ்சல் முகவரி',
  expandBookingHint: 'முழு முன்பதிவு, ரத்து மற்றும் இயக்குநர் மதிப்பீட்டுக்கு கீழே மாத/நாள் பிரிவை விரிவாக்கவும்.',
  experience: 'அனுபவம்',
  exportCsv: 'CSV ஏற்றுமதி',
  failedText: 'தோல்வி',
  feedbackAfterDispatch: 'இயந்திரம் அனுப்பப்பட்ட பிறகு இயக்குநர் மதிப்பீடு கிடைக்கும்.',
  feedbackStatusAfterDispatch: 'அனுப்புதலுக்குப் பிறகு',
  feedbackStatusRateNow: 'இயக்குநரை மதிப்பிடு ↓',
  filterAll: 'அனைத்தும்',
  filterCredit: 'கிரெடிட்',
  filterDebit: 'டெபிட்',
  filterCompleted: 'முடிந்தது',
  filterCancelled: 'மூடப்பட்டது',
  filterPending: 'நிலுவை',
  filterDisputed: 'விவாதம்',
  forgotPasswordChooseMethod: 'கடவுச்சொல் reset-க்கு மின்னஞ்சல் link அல்லது SMS OTP தேர்ந்தெடுக்கவும்.',
  forgotPasswordEmailDevHint: 'Local dev: API server terminal திறந்து “Password reset link (development)” URL நகலெடுக்கவும்.',
  forgotPasswordEmailHint: 'பதிவு செய்த அட்மின் மின்னஞ்சல் முகவரியை உள்ளிடவும்.',
  forgotPasswordFailed: 'Reset link அனுப்ப முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
  forgotPasswordIntro: 'பதிவு செய்த மின்னஞ்சல் முகவரிக்கு பாதுகாப்பான reset link அனுப்புவோம்.',
  forgotPasswordInvalidEmail: 'செல்லுபடியாகும் மின்னஞ்சல் முகவரியை உள்ளிடவும்.',
  forgotPasswordInvalidOtp: 'SMS-லிருந்து 6 இலக்க OTP உள்ளிடவும்.',
  forgotPasswordInvalidPhone: 'செல்லுபடியாகும் 10 இலக்க மொபைல் எண்ணை உள்ளிடவும்.',
  forgotPasswordLink: 'கடவுச்சொல் மறந்துவிட்டீர்களா?',
  forgotPasswordOtpSentTo: 'OTP அனுப்பப்பட்டது:',
  forgotPasswordPhoneHint: 'பதிவு செய்த மொபைல் எண்ணை உள்ளிடவும். Reset link உங்கள் கணக்கின் மின்னஞ்சலுக்கு செல்லும்.',
  forgotPasswordSending: 'அனுப்புகிறது...',
  forgotPasswordSendingOtp: 'OTP அனுப்புகிறது...',
  forgotPasswordSendOtp: 'OTP அனுப்பு',
  forgotPasswordSmsDevHint: 'Production-ல் SMS இன்னும் setup இல்லை — development-ல் OTP code-க்கு server logs பார்க்கவும்.',
  forgotPasswordSmsFailed: 'OTP அனுப்ப முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
  forgotPasswordSmsHint: 'பதிவு செய்த மொபைல் எண்ணை உள்ளிடவும். 6 இலக்க OTP SMS வழியாக அனுப்பப்படும்.',
  forgotPasswordSmsSuccess: 'கணக்கு இருந்தால், பதிவு செய்த மொபைலுக்கு OTP அனுப்பப்பட்டது.',
  forgotPasswordSubmit: 'Reset link அனுப்பு',
  forgotPasswordSuccess: 'கணக்கு இருந்தால், பதிவு செய்த மின்னஞ்சலுக்கு reset வழிமுறைகள் அனுப்பப்பட்டுள்ளன.',
  forgotPasswordTitle: 'உங்கள் கடவுச்சொல்லை மீட்டமை',
  formLabel: 'படிவம்',
  fuel: 'எரிபொருள்',
  fuelColon: 'எரிபொருள்:',
  fuelHistoryTitle: 'எரிபொருள் வரலாறு',
  fuelLevel: 'எரிபொருள் அளவு',
  fuelLevelUpdate: 'எரிபொருள் அளவு புதுப்பிப்பு',
  fuelNotePlaceholder: 'குறிப்பு: நிரப்பிய / பயன்படுத்திய எரிபொருள்...',
  fullName: 'முழு பெயர்',
  goBook: '→ இயந்திரம் முன்பதிவு',
  gpsLiveLabel: '🟢 GPS நேரடி',
  grandTotal: 'மொத்த தொகை',
  grandTotalText: 'மொத்த தொகை',
  gross: 'மொத்த',
  grossBilling: 'மொத்த பில்லிங்',
  gst18: 'GST (18%)',
  gstin: 'GSTIN',
  gstInvoice: 'GST இன்வாய்ஸ்',
  gstInvoices: 'GST இன்வாய்ஸ்கள்',
  hide: 'மறை',
  highTrend: 'HIGH Trend',
  hitsText: 'hits',
  hmrHrs: 'மணி',
  hmrToday: 'இன்றைய HMR',
  hmrTotal: 'மொத்த HMR',
  home: 'முகப்பு',
  hours: 'மணிநேரம்',
  hrsUnit: 'மணி',
  idle: 'செயலற்ற',
  ifsc: 'IFSC',
  ignition: 'Ignition',
  importantInfo: 'இயந்திர உரிமையாளர்களுக்கு முக்கிய தகவல்',
  instantCost: 'உடனடி செலவு கணக்கிடி',
  invoiceNotAvailableCancelled: 'விலைப்பட்டியல் இல்லை (ரத்து)',
  iot: 'IoT & GPS',
  issueReportedSuccess: 'சிக்கல் வெற்றிகரமாக பதிவு செய்யப்பட்டது!',
  issueReportTitle: 'சிக்கல் அறிக்கை',
  issues: 'சிக்கல்கள்',
  joinUsAction: 'Join Us — இலவச பதிவு',
  joinUsBanner: 'இயந்திரம் வாடகைக்கு வேண்டுமா?',
  joinUsHint: 'புதிய வாடிக்கையாளர்? JCB, excavator, crane முன்பதிவு செய்ய இலவச பதிவு.',
  landingCtaApp: 'Development Express ஆராயுங்கள்',
  landingFeatBook: 'நிமிடங்களில் முன்பதிவு',
  landingFeatBookDesc: 'JCB, excavators, cranes — live availability & instant booking.',
  landingFeatPay: 'Wallet-only payments',
  landingFeatPayDesc: 'வெளிப்படையான பில்லிங், GST invoices, பணக் குழப்பம் இல்லை.',
  landingFeatTrack: 'Live GPS tracking',
  landingFeatTrackDesc: 'வாடகை ஒவ்வொரு மணிக்கும் உங்கள் இயந்திரம் எங்கே என்பதை அறியுங்கள்.',
  landingHeroLine1: 'Smarter & Simpler.',
  landingHeroLine2: 'மகாராஷ்டிர இயந்திர வாடகை — புதிய முறை.',
  landingSocialProof: 'மகாராஷ்டிரம் முழுவதும் builders, contractors & fleet உரிமையாளர்கள்.',
  landingStatMachines: 'இயந்திரங்கள்',
  landingStatRating: 'மதிப்பீடு',
  landingTrustLine: 'Wallet-only · GST compliant · Secured operations',
  lastRefreshed: 'கடைசி புதுப்பிப்பு',
  live: 'நேரடி',
  liveBookAvail: 'முன்பதிவுக்குப் பிறகு நேரடி feed கிடைக்கும்',
  liveCamera: '360° நேரடி கேமரா — முன்பதிவுக்குப் பிறகு',
  liveMachineLocation: 'நேரடி இயந்திர இடம்',
  liveText: 'நேரடி',
  liveTracking: 'நேரடி டிராக்கிங்',
  loadedBookings: 'ஏற்றப்பட்ட முன்பதிவுகள்',
  loadedDlqItems: 'ஏற்றப்பட்ட DLQ உருப்படிகள்',
  loadedFuelLogs: 'ஏற்றப்பட்ட எரிபொருள் பதிவுகள்',
  loadedOwnerBookings: '{count} உரிமையாளர் முன்பதிவுகள் ஏற்றப்பட்டது{suffix}',
  loading: 'ஏற்றுகிறது...',
  loadingDashboard: 'டாஷ்போர்ட் ஏற்றுகிறது...',
  loadMoreAlerts: 'மேலும் எச்சரிக்கைகள் ஏற்று',
  loadMoreAttendance: 'மேலும் வருகை ஏற்று',
  loadMoreBookings: 'மேலும் முன்பதிவுகள் ஏற்று',
  loadMoreDlq: 'மேலும் DLQ ஏற்று',
  loadMoreFuelLogs: 'மேலும் எரிபொருள் பதிவுகள் ஏற்று',
  loadMoreLogs: 'மேலும் பதிவுகள் ஏற்று',
  loadMoreMachines: 'மேலும் இயந்திரங்கள் ஏற்று',
  loadMoreTransactions: 'மேலும் பரிவர்த்தனைகள் ஏற்று',
  loadMoreUsers: 'மேலும் பயனர்கள் ஏற்று',
  location: 'இடம்',
  lockConfirm: '🔒 பூட்டலை உறுதிப்படுத்து',
  locked: 'பூட்டப்பட்டது',
  lockMachine: 'இயந்திரம் பூட்டு',
  lockWarning: 'Teltonika GPS வழியாக இயந்திர ignition தொலைவிலிருந்து நிறுத்தப்படும்.',
  loginAs: 'உள்நுழைகிறார்',
  loginChangeRole: 'பாத்திரம் மாற்று',
  loginClientPortalSubtitle: 'கட்டுமான இயந்திரம் முன்பதிவு செய்ய உள்நுழையுங்கள்',
  loginEmailHint: 'அட்மின் உள்நுழைவுக்கு பதிவு செய்த மின்னஞ்சலைப் பயன்படுத்தவும்.',
  loginFailedGeneric: 'உள்நுழைவு தோல்வி — மீண்டும் முயற்சிக்கவும்',
  loginIAmQuestion: 'நான் யார்…?',
  loginModeOtp: 'OTP உள்நுழைவு',
  loginModePassword: 'கடவுச்சொல்',
  loginNewHereRegister: 'புதியவரா? பதிவு',
  loginOtpDevHint: 'Development: SMS இல்லை என்றால் API server log-ல் OTP பார்க்கவும்.',
  loginOtpHint: 'பதிவு செய்த மொபைல் எண்ணுக்கு 6 இலக்க OTP அனுப்பப்படும்.',
  loginOtpSentTo: 'OTP அனுப்பப்பட்டது:',
  loginOwnerPortalSubtitle: 'Fleet & பதிவு நிர்வகிக்க உள்நுழையுங்கள்',
  loginPhoneHint: 'வாடிக்கையாளர், உரிமையாளர் மற்றும் இயக்குநர் உள்நுழைவுக்கு பதிவு செய்த மொபைல் எண்ணைப் பயன்படுத்தவும்.',
  loginPickRoleHint: 'பதிவு செய்தவரா? பாத்திரம் தேர்ந்தெடுக்கவும். புதியவரா? கீழே Join Us.',
  loginPortalAdminSubtitle: 'தள கட்டுப்பாடு & அனுமதிகள்',
  loginPortalAdminTitle: 'அட்மின் போர்டல்',
  loginPortalClientSubtitle: 'கட்டுமான இயந்திரம் புக் செய்ய உள்நுழையுங்கள்',
  loginPortalClientTitle: 'வாடிக்கையாளர் போர்டல்',
  loginPortalOperatorSubtitle: 'ஒதுக்கப்பட்ட இயந்திரங்களுக்கு உள்நுழையுங்கள்',
  loginPortalOperatorTitle: 'ஆபரேட்டர் போர்டல்',
  loginPortalOwnerSubtitle: 'கப்பல் & பதிவு நிர்வகிக்க உள்நுழையுங்கள்',
  loginPortalOwnerTitle: 'உரிமையாளர் போர்டல்',
  loginRoleAdminDesc: 'தள கட்டுப்பாடு, அனுமதிகள் & செயல்பாடுகள்',
  loginRoleClientDesc: 'கட்டுமான திட்டங்களுக்கு இயந்திரம் புக் செய்யுங்கள்',
  loginRoleClientShort: 'வாடிக்கையாளர்',
  loginRoleOperatorDesc: 'ஒதுக்கப்பட்ட இயந்திரங்கள் & தினசரி பதிவுகள்',
  loginRoleOwnerDesc: 'கப்பல், வருவாய் & கிடைப்பு நிர்வகிக்கவும்',
  loginRoleOwnerShort: 'உரிமையாளர்',
  loginSendingOtp: 'OTP அனுப்புகிறது...',
  loginSendOtp: 'OTP அனுப்பு',
  loginSignInShort: 'உள்நுழை',
  loginTabOtp: 'OTP',
  loginTabPassword: 'கடவுச்சொல்',
  loginVerifyingOtp: 'Verify செய்கிறது...',
  loginVerifyOtp: 'Verify & Sign In',
  logout: 'வெளியேறு',
  sessionRevokedAlert: 'நீங்கள் வேறொரு சாதனத்தில் உள்நுழைந்துள்ளீர்கள். மீண்டும் உள்நுழையவும்.',
  machine: 'இயந்திரம்',
  machineDefaultLabel: 'இயந்திரம்',
  machineDetails: 'இயந்திர & இயக்குநர் விவரங்கள்',
  machineDetailsTitle: 'இயந்திர விவரங்கள்',
  machineDispatchedAt: 'இயந்திரம் அனுப்பப்பட்டது — {when}',
  machineHours: 'இயந்திர மணிநேரம்',
  machineIdLabel: 'இயந்திர ID',
  machineInfo: 'இயந்திர தகவல்',
  machineLabel: 'இயந்திரம்',
  machineLog: 'இயந்திர பதிவு',
  machineReg: 'இயந்திர பதிவு படிவம்',
  machineRegistrationSubmitted: 'இயந்திர பதிவு சமர்ப்பிக்கப்பட்டது! DE குழு 24 மணி நேரத்தில் சரிபார்க்கும்.',
  machineRegistrationTitle: 'இயந்திர பதிவு',
  machines: 'இயந்திரங்கள்',
  machineStatus: 'இயந்திர நிலை',
  machineStatusTitle: 'இயந்திர நிலை',
  marketingBackHome: 'வலைத்தளத்துக்குத் திரும்பு',
  marketingBadge: 'LIVE OPERATIONS · KARAD, SATARA',
  marketingBuiltFor: 'துல்லியம், இணக்கம், வேகம் வேண்டிய இந்திய கட்டுமான குழுக்களுக்கு.',
  marketingCtaBook: 'இயந்திரம் முன்பதிவு',
  marketingCtaLogin: 'Development Express திற — Login',
  marketingCtaWhatsApp: 'WhatsApp செய்',
  marketingFooterRights: '2026 Development Express · Karad, Satara · All rights reserved',
  marketingHeadline: 'மகாராஷ்டிரத்தின் leading machinery rental platform',
  marketingLead: 'Real-time GPS tracking, digital wallet payments, and automated operations for construction machinery. Serving Maharashtra since 2011.',
  marketingNavContact: 'தொடர்பு',
  marketingNavLogin: 'தளம் உள்நுழைவு →',
  marketingNavServices: 'சேவைகள்',
  marketingNavTech: 'Technology',
  marketingServicesTitle: 'நாம் வழங்குவது',
  marketingStatDigital: 'Digital payments',
  marketingStatFleet: 'Live machines',
  marketingStatYears: 'ஆண்டுகள் அனுபவம்',
  marketingSvcOps: 'Full operations stack',
  marketingSvcOpsSub: 'Owner, operator, and client — one platform.',
  marketingSvcPay: 'Wallet-only settlements',
  marketingSvcPaySub: 'GST-ready invoicing — no cash on site.',
  marketingSvcTrack: 'GPS & live status',
  marketingSvcTrackSub: 'Teltonika-linked fleet visibility for every booking.',
  marketingTechLead: 'Development Express ties bookings, compliance, and field telemetry into a single hardened workflow — from first enquiry to final invoice.',
  md: 'MD',
  mediumTrend: 'MEDIUM Trend',
  minAdvanceRequired: 'குறைந்தபட்ச முன்பணம் தேவை',
  minimumAdvance: 'குறைந்தபட்ச முன்பணம் தேவை',
  minimumRecharge: 'UPI/கார்டுக்கு குறைந்தபட்ச ₹1',
  mobileNumber: 'மொபைல் எண்',
  monthMachineSummary: 'இந்த மாத இயந்திரங்கள்',
  months: 'மாதங்கள்',
  monthTotalLabel: 'மாத மொத்தம்',
  moreAvailable: 'மேலும் கிடைக்கிறது',
  moUnit: 'மாதம்',
  myBookings: 'எனது முன்பதிவுகள்',
  myClientRating: 'எனது வாடிக்கையாளர் மதிப்பீடு',
  myMachines: 'எனது இயந்திரங்கள்',
  neftRtgs: 'NEFT/RTGS',
  netEarnedMonth: 'நிகர வருமானம் (மாதம்)',
  netPaid: 'நிகர செலுத்தப்பட்டது',
  netPayable: 'நிகர செலுத்த வேண்டிய',
  netReceived: 'நிகர பெற்றது',
  netReceivedCaps: 'நிகர பெற்றது',
  neverText: 'ஒருபோதும் இல்லை',
  newBooking: 'புதிய முன்பதிவு',
  newClientRegister: 'புதிய வாடிக்கையாளர்? இங்கே பதிவு செய்யவும்',
  newClientRegistration: 'புதிய வாடிக்கையாளர் பதிவு',
  newPassword: 'புதிய கடவுச்சொல்',
  nextText: 'அடுத்து',
  noAlerts: 'எச்சரிக்கைகள் இல்லை!',
  noAlertsNow: 'இப்போது எச்சரிக்கைகள் இல்லை.',
  noBankRefund: '❌ வங்கி பணம் திரும்பப் பெற இல்லை — வாலட் கிரெடிட் மட்டும்',
  noBookings: 'செயலில் உள்ள முன்பதிவுகள் இல்லை',
  noBookingsAccount: 'இந்த கணக்கிற்கு இன்னும் முன்பதிவு இல்லை.',
  noBookingsYet: 'இன்னும் முன்பதிவுகள் இல்லை',
  noClientFeedbackYet: 'இன்னும் வாடிக்கையாளர் மதிப்பீடுகள் இல்லை. அனுப்புதலுக்குப் பிறகு வாடிக்கையாளர் கருத்து இங்கே தோன்றும்.',
  noDlqItems: 'DLQ உருப்படிகள் இல்லை',
  noFileSelected: 'கோப்பு தேர்ந்தெடுக்கப்படவில்லை',
  noMachinesDashboard: 'இன்னும் இயந்திரங்கள் இல்லை. Fleet-ஐ சேர்க்க இயந்திர பதிவு பயன்படுத்தவும்.',
  noMachinesTrack: 'டிராக் செய்ய இயந்திரங்கள் இல்லை',
  noMachinesTrackHint: 'GPS டிராக்கிங்குக்கு இயந்திரம் பதிவு செய்யவும்.',
  noMachinesYet: 'இன்னும் இயந்திரங்கள் பதிவு செய்யப்படவில்லை',
  noMoreAuditLogs: 'தற்போதைய வடிகட்டிகளுக்கு மேலும் ஆடிட் பதிவுகள் இல்லை.',
  noRecentApiSloBreach: 'சமீபத்திய API SLO breach சிக்னல்கள் இல்லை.',
  noRecentFailedLogins: 'சமீபத்திய தோல்வியடைந்த உள்நுழைவு முயற்சிகள் இல்லை.',
  noRefund: 'பணம் திரும்பப் பெற முடியாது கொள்கை',
  normalText: 'சாதாரண',
  noSecuritySignalsFound: 'பாதுகாப்பு சிக்னல்கள் கிடைக்கவில்லை.',
  noTransactionsFilter: 'தேர்ந்தெடுத்த வடிகட்டிக்கு பரிவர்த்தனைகள் இல்லை.',
  off: 'OFF',
  officeLabel: 'அலுவலகம்',
  on: 'ON',
  operator: 'இயக்குநர்',
  operatorFeedbackColumn: 'இயக்குநர் கருத்து',
  operatorFeedbackSaved: 'நன்றி! உங்கள் கருத்து சேமிக்கப்பட்டது.',
  operatorFeedbackSubmitted: 'உங்கள் கருத்து',
  operatorFeedbackTitle: 'இயக்குநர் கருத்து',
  operatorPortal: 'இயக்குநர் போர்ட்டல்',
  operatorRole: 'இயக்குநர்',
  operators: 'இயக்குநர்கள்',
  operatorSatisfactionQuestion: 'இயக்குநருடன் திருப்தியா?',
  operatorSuggestionPlaceholder: 'பரிந்துரை அல்லது கருத்து (விரும்பினால்)',
  optionalLabel: '(விரும்பினால்)',
  otpCode: 'OTP குறியீடு',
  overview: 'கண்ணோட்டம்',
  ownerBookingsAllLoaded: ' (அனைத்தும் ஏற்றப்பட்டது)',
  ownerBookingsMoreAvailable: ' (மேலும் உள்ளது)',
  ownerInfo: 'உரிமையாளர் தகவல்',
  ownerPortal: 'உரிமையாளர் போர்ட்டல்',
  ownerRole: 'இயந்திர உரிமையாளர்',
  owners: 'உரிமையாளர்கள்',
  password: 'கடவுச்சொல்',
  passwordsMustMatch: 'கடவுச்சொல் மற்றும் உறுதிப்படுத்தல் ஒன்றாக இருக்க வேண்டும்.',
  pastIssuesTitle: 'கடந்த சிக்கல்கள்',
  paymentBreakdownTitle: 'பணம் விவரம் — April 2026',
  paymentCycle: 'பணம் செலுத்தும் சுழற்சி',
  paymentFailed: 'பணம் செலுத்துதல் தோல்வி! மீண்டும் முயற்சிக்கவும்.',
  paymentHistory: 'பணம் செலுத்திய வரலாறு',
  paymentHistoryTitle: 'பணம் செலுத்திய வரலாறு',
  paymentMethods: 'பணம் செலுத்தும் முறைகள்',
  paymentMode: 'பணம் செலுத்தும் முறை',
  paymentSuccess: 'பணம் செலுத்துதல் வெற்றி!',
  payNow: 'இப்போது செலுத்து',
  payNowText: 'இப்போது செலுத்து',
  pdfInvoiceFailed: 'விலைப்பட்டியல் PDF உருவாக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
  pdfReportFailed: 'அறிக்கை PDF உருவாக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
  pdiCompleted: '✅ PDI / Safety inspection முடிந்தது',
  pdiCrawlerHint: 'Crawler plant: pollution (PUC) தேவை இல்லை — இயந்திரம் RTO சாலை-பதிவு செய்யப்படவில்லை.',
  pdiInfo: 'PDI சோதனை',
  pdiInsuranceApplicable: '✅ Insurance / cover (if applicable)',
  pdiInsuranceValid: '✅ Insurance valid & up to date',
  pdiPollutionValid: '✅ Pollution certificate (PUC) valid',
  pdiTitle: 'Pre-Delivery Inspection (PDI)',
  penaltyDeduct: 'ரத்து அபராதம் (1 மணி)',
  pending: 'நிலுவையில்',
  pendingApproval: 'அனுமதி நிலுவையில்',
  pendingCount: '{count} நிலுவை',
  pendingDispatch: 'அனுப்புதல் நிலுவையில்',
  perDay: 'நாளுக்கு',
  perHour: 'மணிக்கு',
  perMonth: 'மாதத்துக்கு',
  perWeek: 'வாரத்துக்கு',
  phone: 'தொலைபேசி',
  platform: 'கட்டுமான நிர்வாக தளம்',
  platformAgreement: 'தள ஒப்பந்தம்',
  policyLabel: 'கொள்கை',
  policyTopicBooking: 'முன்பதிவு',
  policyTopicCancellation: 'ரத்து',
  policyTopicContact: 'தொடர்பு',
  policyTopicGst: 'GST',
  policyTopicHours: 'ஆதரவு நேரம்',
  portalBackLink: 'போர்ட்டல்',
  portalClient: 'வாடிக்கையாளர்',
  portalClientSub: 'இயந்திரம் முன்பதிவு',
  portalNewClientRegister: 'புதிய வாடிக்கையாளர்? பதிவு',
  portalNewOwnerRegister: 'புதிய உரிமையாளர்? பதிவு',
  portalOwner: 'உரிமையாளர்',
  portalOwnerSub: 'Fleet நிர்வகிப்பு',
  portalStaffAdmin: 'அட்மின்',
  portalStaffOperator: 'இயக்குநர்',
  portalWelcome: 'வரவேற்கிறோம்',
  portalWelcomeHint: 'தொடர உங்கள் போர்ட்டலைத் தேர்ந்தெடுக்கவும்',
  quantityLabel: 'அளவு',
  quickIssueReport: 'விரைவு சிக்கல் அறிக்கை',
  quickRechargeUpi: 'UPI வழி விரைவு ரீசார்ஜ்',
  quickSelect: 'விரைவு தேர்வு:',
  rateCard: 'விலை அட்டை (இயக்குநர் உட்பட)',
  rateLimitTelemetryTitle: 'Rate Limit Telemetry',
  rateOperatorWork: 'இயக்குநர் வேலையை மதிப்பிடு (1–5 stars)',
  rating: 'மதிப்பீடு',
  receiptId: 'ரசீது ID',
  recentAlerts: 'சமீபத்திய எச்சரிக்கைகள்',
  recentFailedLoginsTitle: 'சமீபத்திய தோல்வியடைந்த உள்நுழைவுகள்',
  recentLabel: 'சமீபத்திய',
  recharge: 'ரீசார்ஜ்',
  rechargeFirst: '⚡ முதலில் வாலட் ரீசார்ஜ் செய்யுங்கள்',
  rechargeWallet: '+ வாலட் ரீசார்ஜ்',
  ref: 'குறிப்பு எண்',
  refreshingText: 'புதுப்பிக்கிறது...',
  refreshText: 'புதுப்பி',
  regCapacitySpecs: 'திறன் / விவரங்கள்',
  regDocCrawlerHint: 'Crawler (excavator): chassis plate, machine purchase invoice, machine photo மற்றும் ID தேவை. Insurance optional.',
  regDocWheeledHint: 'Wheeled: RC (RTO), insurance, PUC மற்றும் ID தேவை (ஒவ்வொன்றும் 5MB).',
  regEquipmentCategory: 'உபகரண வகை *',
  regFailed: 'பதிவு தோல்வி. மீண்டும் முயற்சிக்கவும்.',
  regFileSizeError: 'ஒவ்வொரு document-ம் 5MB அல்லது குறைவாக இருக்க வேண்டும்',
  regFileTypeError: 'PDF, JPG, PNG அல்லது WEBP கோப்புகள் மட்டும் அனுமதிக்கப்படும்',
  regFleetIdOptional: 'Fleet / chassis ID (விரும்பினால்)',
  register: 'இயந்திரம் பதிவு',
  registerAction: 'பதிவு செய்',
  registering: 'பதிவு செய்கிறது...',
  registerMachine: 'இயந்திரம் பதிவு',
  registrationPending: 'அட்மின் 24 மணி நேரத்தில் உங்கள் கணக்கை செயல்படுத்துவார்.',
  registrationSuccess: 'பதிவு வெற்றி!',
  regMachineCategory: 'இயந்திர வகை *',
  regMachineInfoTitle: 'இயந்திர தகவல்',
  regMachineIntro: 'கட்டுமான heavy equipment மட்டும் — truck/transport இல்லை. Wheeled plant (எ.கா. JCB 3DX) க்கு RTO; crawler plant (Poclain, dozer) site-மட்டும் — RTO passing இல்லை.',
  regMachineNameModel: 'இயந்திர பெயர் / மாடல்',
  regMobilityTracked: 'Crawler',
  regMobilityTrackedHint: 'Poclain / chain excavator, dozer, crawler crane — site plant, RTO passing இல்லை',
  regMobilityWheeled: 'Wheeled',
  regMobilityWheeledHint: 'JCB 3DX, wheeled loader, grader — RTO (RC) உள்ள கட்டுமான plant',
  machineFinancialSection: 'இயந்திர கொள்முதல் விவரங்கள் (விருப்ப)',
  machineOwnershipType: 'உரிமை வகை',
  machineOwnershipNew: 'புதிய இயந்திரம்',
  machineOwnershipUsed: 'அசல் உரிமையாளர்',
  machineOwnershipSecondHand: 'முன்-உரிமை',
  machinePurchasePrice: 'கொள்முதல் விலை (₹)',
  machinePurchasePriceHint: 'இந்த இயந்திரத்திற்கு நீங்கள் செலுத்திய தொகை',
  machinePurchaseDate: 'கொள்முதல் தேதி',
  machineYearOfManufacture: 'உற்பத்தி ஆண்டு',
  machineLoanSection: 'இந்த இயந்திரத்தில் எனக்கு loan உள்ளது',
  machineLoanAmount: 'Loan தொகை (₹)',
  machineLoanEmi: 'மாத EMI (₹)',
  machineLoanTenure: 'Loan காலம் (மாதங்கள்)',
  machineLoanStartDate: 'Loan தொடக்க தேதி',
  machineFuelConsumption: 'எரிபொருள் நுகர்வு (L/hr)',
  machineMonthlyOperatingExpenses: 'மாதாந்திர இயக்க செலவுகள்',
  machineOperatorMonthlySalary: 'ஆபரேட்டர் மாதாந்திர சம்பளம்',
  machineServiceMonthly: 'சேவை / பராமரிப்பு (மாதாந்திர)',
  machineBreakdownMonthly: 'கோளாறு / பழுது (மாதாந்திர சராசரி)',
  machineMaterialsMonthly: 'பொருட்கள் / நுகர்பொருள் (மாதாந்திர)',
  recoveryPlan: 'மீட்பு திட்டம்',
  recoveryOnTrack: 'சரியான பாதையில்',
  recoveryNeedsAttention: 'கவனம் தேவை',
  recoveryActionRequired: 'நடவடிக்கை தேவை',
  recoveryAddPrice: 'மீட்பு திட்டத்தைப் பார்க்க வாங்கிய விலையைச் சேர்க்கவும்',
  recoveryProgress: 'முதலீடு மீட்பு',
  recoveryDailyNet: 'தினசரி நிகர வருமானம்',
  recoveryDays: 'மீட்பு காலம்',
  recoveryProjectedDate: 'திட்டமிட்ட மீட்பு தேதி',
  recoveryRoi: 'வருடாந்திர வருவாய்',
  recoveryCurrentValue: 'தற்போதைய இயந்திர மதிப்பு',
  editFinancialDetails: 'நிதி விவரங்களைத் திருத்து',
  financialDetailsSaved: 'நிதி விவரங்கள் சேமிக்கப்பட்டன',
  recoveryBackfillNudge: 'மீட்பு கண்காணிப்பைத் திற {{count}} இயந்திரம்(களில்) வாங்கிய விவரங்களைச் சேர்க்கவும்',
  dieselPriceTitle: 'டீசல் விலை',
  dieselPriceUpdate: 'டீசல் விலை புதுப்பிக்க',
  dieselPriceLatest: 'சமீபத்திய விலை',
  dieselPriceNoRecord: 'டீசல் விலை பதிவு இல்லை',
  dieselPricePerLitre: 'லிட்டர் விலை (₹)',
  dieselQuantity: 'நிரப்பிய அளவு (லிட்டர்)',
  dieselTaluka: 'நகரம் / பகுதி',
  bookingAttachment: 'இணைப்பைத் தேர்ந்தெடுக்கவும்',
  bookingAttachmentNone: 'குறிப்பிட்ட இணைப்பு இல்லை',
  bookingWorkDescription: 'பணி விவரம்',
  bookingWorkDescriptionPlaceholder: 'எ.கா. அடித்தள தோண்டல், அகழி, குழாய் வேலை',
  bookingAttachmentLabel: 'இணைப்பு',
  bookingSiteLabel: 'தளம்',
  bookingWorkLabel: 'பணி',
  termsAccept: "நான் விதிமுறைகள் மற்றும் நிபந்தனைகளை ஏற்கிறேன்",
  termsRequired: "பதிவு செய்ய விதிமுறைகள் மற்றும் நிபந்தனைகளை ஏற்க வேண்டும்",
  termsLink: "விதிமுறைகள் மற்றும் நிபந்தனைகள்",
  clientBlacklisted: "பிளாக்லிஸ்ட்",
  clientBlacklistReason: "பிளாக்லிஸ்ட் காரணம்",
  clientBlacklistConfirm: "இந்த கிளையண்டை பிளாக்லிஸ்ட் செய்யவா?",
  clientUnblacklist: "பிளாக்லிஸ்ட்டிலிருந்து நீக்கு",
  blacklistedClients: "பிளாக்லிஸ்ட் கிளையண்டுகள்",
  blacklistedClientsEmpty: "பிளாக்லிஸ்ட் கிளையண்டுகள் இல்லை",
  managerAccessRestricted: "நிதி அணுகல் தடைசெய்யப்பட்டது. ஓம் சவான் தொடர்பு கொள்ளவும்.",
  managerSection: "மேலாளர்கள்",
  managerAdd: "மேலாளர் சேர்",
  managerName: "மேலாளர் பெயர்",
  managerEmail: "மேலாளர் மின்னஞ்சல்",
  managerPassword: "தற்காலிக கடவுச்சொல்",
  managerCreated: "மேலாளர் கணக்கு உருவாக்கப்பட்டது",
  managerCredentialsTitle: "மேலாளர் உள்நுழைவு விவரங்கள்",
  managerCredentialsSubtitle: "இந்த விவரங்களை இப்போதே சேமிக்கவும் — கடவுச்சொல் பின்னர் மீட்க முடியாது",
  managerCredentialsSaved: "விவரங்களை சேமித்துவிட்டேன்",
  managerLoginUrl: "உள்நுழைவு URL",
  managerActivity: "மேலாளர் செயல்பாடு",
  managerActivityEmpty: "இன்னும் எந்த செயல்பாடும் பதிவு செய்யப்படவில்லை",
  managerActivityViewAll: "அனைத்து செயல்பாட்டையும் காண்க",
  onboardingTitle: "தொடங்குங்கள்",
  onboardingAccountApproved: "கணக்கு அனுமதிக்கப்பட்டது",
  onboardingKycComplete: "KYC சரிபார்ப்பு முடிந்தது",
  onboardingKycPending: "KYC சரிபார்ப்பை முடிக்கவும்",
  onboardingKycRejected: "KYC நிராகரிக்கப்பட்டது — மீண்டும் சமர்ப்பிக்கவும்",
  onboardingWalletFunded: "வாலட்டில் இருப்பு உள்ளது",
  onboardingWalletEmpty: "பதிவுக்கு வாலட் இருப்பு சேர்க்கவும்",
  pushEnablePrompt: "உடனடி புதுப்பிப்புகளுக்கு புஷ் அறிவிப்புகளை இயக்கவும்",
  downloadDisputeStatement: "சர்ச்சை அறிக்கையை பதிவிறக்கவும்",
  downloadInvoice: "விலைப்பட்டியலைப் பதிவிறக்கவும்",
  bookAgain: "மீண்டும் முன்பதிவு செய்யுங்கள்",
  machineNoLongerAvailable: "இயந்திரம் இப்போது கிடைக்கவில்லை",
  downloadHistoryPdf: "வரலாறு PDF பதிவிறக்கவும்",
  onboardingFirstBooking: "உங்கள் முதல் பதிவை செய்யுங்கள்",
  onboardingAllDone: "நீங்கள் தயாராக உள்ளீர்கள்!",
  onboardingTrackerTitle: "பதிவு முன்னேற்றம்",
  onboardingTrackerTarget: "பதிவு இலக்கு: 48 மணி",
  onboardingTrackerInProgress: "நடைபெறுகிறது",
  onboardingTrackerActionRequired: "நடவடிக்கை தேவை",
  onboardingTrackerComplete: "முடிந்தது",
  onboardingTrackerPending: "நிலுவை",
  onboardingTrackerPhase1: "பதிவு",
  onboardingTrackerPhase2: "KYC சரிபார்ப்பு",
  onboardingTrackerPhase3: "இயந்திரப் பதிவு",
  onboardingTrackerPhase4: "முதல் முன்பதிவு தயார்",
  onboardingTrackerHelper1: "இயந்திரப் பதிவைத் திறக்க ஆதார் + செல்ஃபி பதிவேற்றவும்",
  onboardingTrackerHelper2: "KYC மதிப்பாய்வில் — பொதுவாக 24 மணிக்குள்",
  onboardingTrackerHelper3: "KYC நிராகரிக்கப்பட்டது — ஆவணங்களை மீண்டும் சமர்ப்பிக்கவும்",
  onboardingTrackerHelper4: "KYC அனுமதி — உங்கள் முதல் இயந்திரத்தைச் சேர்க்கவும்",
  onboardingTrackerHelper5: "இயந்திரம் நிர்வாக மதிப்பாய்வில்",
  onboardingTrackerHelper6: "இயந்திரம் நேரடி — முதல் முன்பதிவுக்காக காத்திருப்பு",
  onboardingTrackerPhaseLabel: "கட்டம்",
  alertsAndNotifications: 'எச்சரிக்கைகள் & அறிவிப்புகள்',
  dieselFuelCostPerHour: 'மணிக்கு எரிபொருள் செலவு',
  dieselPercentOfRate: 'உங்கள் மணி விகிதத்தின்',
  dieselPriceSaved: 'டீசல் விலை சேமிக்கப்பட்டது',
  dieselRateSuggestion: 'விகித பரிந்துரை',
  dieselRateIncrease: 'டீசல் உயர்ந்தது — விகிதம் உயர்த்த பரிசீலிக்கவும்',
  dieselRateDecrease: 'டீசல் குறைந்தது — முன்பதிவுகளுக்கு விகிதம் குறைக்கவும்',
  dieselSuggestedRate: 'பரிந்துரைக்கப்பட்ட விகிதம்',
  dieselHistory: 'விலை வரலாறு',
  dieselNoHistory: 'டீசல் விலை வரலாறு இன்னும் இல்லை',
  dieselColDate: 'தேதி',
  dieselColPrice: 'விலை/லிட்டர்',
  dieselColQty: 'அளவு',
  dieselColSource: 'மூலம்',
  dieselUploadReceipt: 'ரசீது பதிவேற்றம்',
  dieselExtractSuccess: 'ரசீதிலிருந்து பிரித்தெடுக்கப்பட்டது',
  dieselExtractFailed: 'பிரித்தெடுக்க முடியவில்லை — கைமுறையாக உள்ளிடவும்',
  applyRateSuggestion: '₹{{rate}}/மணி பயன்படுத்து',
  rateSuggestionApplied: 'விகிதம் வெற்றிகரமாக புதுப்பிக்கப்பட்டது',
  marketPosition: 'சந்தை நிலை',
  marketBelowMarket: 'சந்தையை விட குறைவு',
  marketCompetitive: 'போட்டியிடும்',
  marketAboveMarket: 'சந்தையை விட அதிகம்',
  marketNoData: 'உங்கள் பகுதிக்கு இன்னும் சந்தை தரவு இல்லை',
  marketSubmitRate: 'சந்தை விகிதம் சமர்ப்பிக்கவும்',
  marketCity: 'நகரம் / பகுதி',
  marketMinRate: 'உங்கள் பகுதியில் குறைந்தபட்ச விகிதம் (₹/மணி)',
  marketMaxRate: 'உங்கள் பகுதியில் அதிகபட்ச விகிதம் (₹/மணி)',
  marketRateSubmitted: 'சந்தை விகிதம் சமர்ப்பிக்கப்பட்டது — நன்றி!',
  marketDataPoints: '{{count}} சமர்ப்பிப்பு(கள்) அடிப்படையில்',
  marketRange: '{{city}} இல் சந்தை',
  marketSourceLocal: '{{city}} பகுதி விகிதங்களின் அடிப்படையில்',
  marketSourcePlatform: 'தளம் முழுவதும் உள்ள விகிதங்களின் அடிப்படையில்',
  regPremiumOnboarding: 'Premium onboarding',
  regRtoNumber: 'RTO பதிவு எண் *',
  regSelectType: 'வகையைத் தேர்ந்தெடுக்கவும்…',
  regSubmitBtn: '✅ பதிவு சமர்ப்பி',
  regTagNoRto: 'RTO இல்லை',
  regTagRto: 'RTO',
  regYearManufacture: 'உற்பத்தி ஆண்டு *',
  remoteLockAlert: 'Teltonika GPS device இந்த இயந்திரத்தில் நிறுவப்பட்ட பிறகு remote lock enable ஆகும். DE support-ஐ தொடர்பு கொள்ளுங்கள்.',
  remoteLockMachine: '🔒 தொலைவிலிருந்து இயந்திரம் பூட்டு',
  replaceFile: 'மாற்று',
  reports: 'அறிக்கைகள்',
  reportText: 'அறிக்கை',
  resetMethodEmail: 'மின்னஞ்சல் link',
  resetMethodSms: 'SMS OTP',
  resetPasswordFailed: 'கடவுச்சொல் reset செய்ய முடியவில்லை. புதிய link கோரவும்.',
  resetPasswordIntro: 'குறைந்தது 8 எழுத்துகள் கொண்ட வலுவான கடவுச்சொல்லைத் தேர்ந்தெடுக்கவும்.',
  resetPasswordMinLength: 'கடவுச்சொல் குறைந்தது 8 எழுத்துகள் இருக்க வேண்டும்.',
  resetPasswordMissingToken: 'Reset link இல்லை அல்லது செல்லாது. உள்நுழைவிலிருந்து Forgot password பயன்படுத்தவும்.',
  resetPasswordSubmit: 'கடவுச்சொல் புதுப்பி',
  resetPasswordSuccess: 'கடவுச்சொல் புதுப்பிக்கப்பட்டது. உள்நுழைவுக்குத் திருப்புகிறது...',
  resetPasswordTitle: 'புதிய கடவுச்சொல் அமை',
  resetPasswordUpdating: 'புதுப்பிக்கிறது...',
  resetText: 'மீட்டமை',
  retryDlqItemTitle: 'DLQ உருப்படியை மீண்டும் முயற்சி',
  retryFailedForDlq: 'DLQ உருப்படிக்கு மீண்டும் முயற்சி தோல்வி',
  retryReasonAuditPlaceholder: 'மீண்டும் முயற்சி காரணம் (ஆடிட்டுக்கு)',
  retryText: 'மீண்டும் முயற்சி',
  revenue: 'வருவாய்',
  running: 'இயங்குகிறது',
  satisfiedNo: 'திருப்தி இல்லை',
  satisfiedYes: 'ஆம், திருப்தி',
  save: 'சேமி',
  scanToPay: 'பணம் செலுத்த ஸ்கேன் செய்யுங்கள்',
  scheduleColFeedback: 'கருத்து',
  scheduleColQty: 'Qty',
  scheduleColTotal: 'மொத்தம்',
  scheduleColType: 'வகை',
  securitySignalsTitle: 'பாதுகாப்பு சிக்னல்கள்',
  selectBook: 'இந்த இயந்திரம் முன்பதிவு →',
  selectCalc: '📋 தேர்ந்தெடுத்து செலவு பார் →',
  selectedMachineText: 'தேர்ந்தெடுத்த இயந்திரம்',
  selectFile: 'கோப்பைத் தேர்ந்தெடு',
  selectMachineFirst: 'முதலில் இயந்திரம் தேர்ந்தெடுக்கவும்',
  selectQty: 'அளவைத் தேர்ந்தெடு',
  selectRole: 'பாத்திரத்தைத் தேர்ந்தெடுக்கவும்',
  send: 'அனுப்பு',
  sendEmail: 'மின்னஞ்சல் அனுப்பு',
  sendWhatsapp: 'WhatsApp-ல் அனுப்பு',
  settlements: 'தீர்வுகள்',
  show: 'காட்டு',
  signIn: 'உள்நுழைக',
  signingIn: 'உள்நுழைகிறது...',
  signupCompanyName: 'நிறுவன பெயர்',
  signupContactName: 'தொடர்பு பெயர்',
  signupCreatePassword: 'கடவுச்சொல் உருவாக்கு',
  signupReenterPassword: 'கடவுச்சொல் மீண்டும்',
  signupSectionCompany: 'நிறுவனம்',
  signupSectionContact: 'உங்கள் விவரங்கள்',
  signupSectionSecurity: 'பாதுகாப்பு',
  sinceExcellence: '2011 முதல் · 15 ஆண்டு சிறப்பு',
  sinceLabel: 'முதல்',
  sloBreachRisk: 'SLO BREACH RISK',
  sloHealthy: 'SLO HEALTHY',
  speed: 'வேகம்',
  staleText: 'பழையது',
  status: 'நிலை',
  statusCancelled: 'ரத்து',
  bookingClosed: 'மூடப்பட்டது',
  sectionNew: 'புதிய',
  sectionAccepted: 'ஏற்கப்பட்டது',
  sectionActive: 'செயலில்',
  sectionDispatched: 'அனுப்பப்பட்டது',
  sectionCompleting: 'முடிவடைகிறது',
  sectionDisputed: 'தகராறு',
  sectionCompleted: 'முடிந்தது',
  sectionClosed: 'மூடப்பட்டது',
  statusCompleted: 'முடிந்தது',
  stopped: 'நிறுத்தப்பட்டது',
  submit: 'சமர்ப்பி',
  submitOperatorFeedback: 'கருத்தை சமர்ப்பி',
  submittedRegistrations: 'சமர்ப்பிக்கப்பட்ட பதிவுகள்',
  support: 'ஆதரவு',
  supportPolicyBooking: 'வாலட்-only முன்பணம். தளத்தில் பணம் இல்லை.',
  supportPolicyCancellation: '1 மணி அபராதம்; மீதம் வாலட்டில்.',
  supportPolicyContact: 'DE Support மட்டும் — நேரடி தொடர்பு தடை.',
  supportPolicyGst: 'அனைத்து விலைப்பட்டியலிலும் 18% GST; Reports தாவலில்.',
  supportPolicyHours: 'திங்–சனி, 9–7 IST',
  tableAtt: 'Att',
  tableChange: 'மாற்றம்',
  tableDay: 'நாள்',
  tableEnd: 'முடிவு',
  tableHrs: 'மணி',
  tableId: 'ID',
  tableIn: 'In',
  tableLevel: 'அளவு',
  tableMonth: 'மாதம்',
  tableNote: 'குறிப்பு',
  tableOut: 'Out',
  tableStart: 'தொடக்கம்',
  tagline: 'அடிப்படை வசதி சிறப்பு',
  tax: 'வரி',
  tdsGstTcs: 'TDS 2% + GST TCS 1%',
  tdsTcs: 'TDS+TCS',
  termCommission: 'Development Express கமிஷன்: மொத்த பில்லிங்கின் 15%',
  termFuel: 'இயந்திரத்தில் எப்போதும் 40%+ எரிபொருள் இருக்க வேண்டும்',
  termGps: 'GPS device (Teltonika) கட்டாயம் — DE வழியாக நிறுவப்படும்',
  termGstTcs: 'GST TCS: GST regulations படி 1%',
  termNoDirectContact: 'நேரடி வாடிக்கையாளர் தொடர்பு = உடனடி contract termination',
  termPaymentDays: 'வாடிக்கையாளர் settlement-க்குப் பிறகு 3 வேலை நாட்களில் பணம்',
  termTds: 'TDS deduction: Income Tax Act படி 2%',
  threeWorkingDays: '3 வேலை நாட்கள்',
  timeLabel: 'நேரம்',
  todayText: 'இன்று',
  topSourceIp: 'Top Source IP',
  total: 'மொத்தம்',
  totalAdvanceLabel: 'முன்பணம் செலுத்தப்பட்டது',
  totalBookingsText: 'மொத்த முன்பதிவுகள்',
  totalMachines: 'மொத்த இயந்திரங்கள்',
  totalSpent: 'மொத்த செலவு',
  tracking: 'GPS டிராக்கிங்',
  transactionHistoryTitle: 'பரிவர்த்தனை வரலாறு',
  transactions: 'பரிவர்த்தனை வரலாறு',
  trustStatCompliant: 'இணக்கம்',
  trustStatMachines: 'இயந்திரங்கள்',
  trustStatRating: 'மதிப்பீடு',
  txnDescription: 'விவரம்',
  type: 'வகை',
  understood: '✅ புரிந்தது — தளத்தைப் பயன்படுத்துவேன்',
  understoodAction: 'புரிந்தது',
  unknownText: 'தெரியவில்லை',
  updateFuel: 'எரிபொருள் புதுப்பி',
  updateText: 'புதுப்பி',
  upiAppsHint: 'PhonePe | GPay | Paytm | BHIM',
  uploadFile: 'பதிவேற்றம்',
  valEmail: 'செல்லுபடியாகும் மின்னஞ்சல் தேவை',
  valMachineName: 'இயந்திர பெயர் / model தேவை',
  valMachineType: 'equipment category தேர்ந்தெடுக்கவும்',
  valMobility: 'wheeled அல்லது crawler equipment வகையைத் தேர்ந்தெடுக்கவும்',
  valOwnerName: 'உரிமையாளர் பெயர் தேவை',
  valPdiChecks: 'அனைத்து required checks-ஐயும் confirm செய்யவும்',
  valPdiRequired: 'PDI confirmation தேவை',
  valPhone: 'செல்லுபடியாகும் தொலைபேசி எண் தேவை',
  valRto: 'Wheeled machines-க்கு RTO registration number தேவை',
  valUploadMissing: 'பதிவேற்றவும்: {docs}',
  valYear: 'செல்லுபடியாகும் year (YYYY) தேவை',
  viewMachines: '→ இயந்திரங்கள் பார்',
  wallet: 'வாலட்',
  walletBalance: 'வாலட் இருப்பு',
  walletCredit: 'வாலட் கிரெடிட்',
  walletDebit: 'வாலட் டெபிட்',
  walletDeduct: 'முன்பணம் வாலட்டிலிருந்து கழிக்கப்படும் · பணம் இல்லை · GST தானாக உருவாகும்',
  walletInsufficient: '❌ போதாது',
  walletLowRecharge: 'வாலட் இருப்பு குறைவு — அடுத்த முன்பதிவுக்கு முன் ரீசார்ஜ்',
  walletOnly: 'வாலட் மட்டும் · பணம் ஏற்கப்படாது',
  walletOnlyPolicyDesc: 'அனைத்து பரிவர்த்தனைகளும் வாலட் வழியாக மட்டும். பணம் ஏற்கப்படாது.',
  walletOnlyPolicyTitle: 'வாலட்-மட்டும் கொள்கை',
  walletRechargeTitle: 'வாலட் ரீசார்ஜ்',
  walletSufficient: '✅ தொடரலாம்',
  weeks: 'வாரங்கள்',
  whatsapp: 'WhatsApp',
  wksUnit: 'வாரம்',
  year: 'ஆண்டு',
  yearsExperience: '{n} ஆண்டுகள்',
  yourMessage: 'உங்கள் கேள்வி அல்லது சிக்கலை எழுதுங்கள்...',
  // --- Recent feature strings ---
  retryLabel: 'மீண்டும் முயற்சிக்கவும்',
  payrollPreview: 'சம்பள முன்னோட்டம்',
  payrollRun: 'சம்பளம் இயக்கு',
  payrollAlreadyRun: 'இந்த மாதத்திற்கு சம்பளம் ஏற்கனவே இயக்கப்பட்டது',
  payrollGross: 'மொத்த செலுத்த வேண்டியது',
  payrollNet: 'நிகர செலுத்த வேண்டியது',
  payrollAdvanceDeducted: 'முன்பண கழிவு',
  payrollRunSuccess: 'சம்பளம் வெற்றிகரமாக இயக்கப்பட்டது',
  payrollNoAmount: 'இந்த மாதத்திற்கு செலுத்த வேண்டிய தொகை இல்லை',
  payrollMonth: 'சம்பள மாதம்',
  exportPayrollCsv: 'சம்பள CSV ஏற்றுமதி',
  payrollExportMonth: 'சம்பள ஏற்றுமதி மாதம்',
  payrollDailyRate: 'தினசரி விகிதம்',
  payrollHistory: 'சம்பள வரலாறு',
  payrollNoHistory: 'இன்னும் சம்பளம் இயக்கப்படவில்லை',
  payrollColMonth: 'மாதம்',
  payrollColGross: 'மொத்தம்',
  payrollColDeduction: 'முன்பண கழிப்பு',
  payrollColNet: 'நிகர சம்பளம்',
  payrollColDate: 'தேதி',
  downloadPayslip: 'சம்பள சீட்டு பதிவிறக்க',
  payslipTitle: 'மாத சம்பள சீட்டு',
  payslipEarnings: 'வருமானம்',
  payslipDeductions: 'கழிப்புகள்',
  payslipDaysWorked: 'வேலை நாட்கள்',
  payslipGeneratedBy: 'Development Express மூலம் உருவாக்கப்பட்டது',
  operatorPayrollTitle: 'என் சம்பளம்',
  payrollMonthlySalary: 'மாத சம்பளம்',
  payrollCurrentMonth: 'தற்போதைய மாதம்',
  payrollPreviousMonth: 'முந்தைய மாதம்',
  ownerAttendanceTitle: 'வருகை',
  ownerAttendanceEdit: 'திருத்து',
  ownerAttendanceSave: 'சேமி',
  ownerAttendanceNoRecords: 'இந்த மாதத்திற்கு வருகைப் பதிவுகள் இல்லை',
  ownerAttendanceOverrideSuccess: 'வருகை புதுப்பிக்கப்பட்டது',
  ownerSalaryUpdated: 'சம்பளம் வெற்றிகரமாக புதுப்பிக்கப்பட்டது',
  ownerSalaryEditBtn: 'சம்பளம் திருத்து',
  ownerSalaryNotSet: 'சம்பளம் அமைக்கப்படவில்லை — சம்பளத்தை அமைத்தால் பேரோல் இயங்கும்',
  duration: "காலம்",
  durationLabel: 'காலம்',
  plQuotaLabel: 'PL கோட்டா',
  plUsed: 'பயன்படுத்தியது',
  plAllowed: 'அனுமதி',
  plRemaining: 'மீதம்',
  plQuotaUpdated: 'PL கோட்டா புதுப்பிக்கப்பட்டது',
  plQuotaExhausted: 'PL கோட்டா முடிந்தது — ஊதியமில்லா விடுப்பாக குறிக்கப்பட்டது',
  plRemainingLabel: 'மீதமுள்ள PL',
  noAttendanceRecords: 'இன்னும் வருகைப் பதிவுகள் இல்லை',
  noFuelLogs: 'இன்னும் எரிபொருள் பதிவுகள் இல்லை',
  noIssuesYet: 'இன்னும் எந்த பிரச்சனையும் பதிவாகவில்லை',
  failedToLoad: 'தரவை ஏற்ற முடியவில்லை',
  failedToLoadReport: 'அறிக்கையை ஏற்ற முடியவில்லை',
  failedToLoadIssues: 'பிரச்சனைகளை ஏற்ற முடியவில்லை',
  failedToLoadAlerts: 'எச்சரிக்கைகளை ஏற்ற முடியவில்லை',
  noRecordsMonth: 'இந்த மாதத்திற்கு பதிவுகள் இல்லை',
  underReview: 'மறுஆய்வில்',
  issueResolved: 'தீர்க்கப்பட்டது',
  presentDaysLabel: 'வருகை நாட்கள்',
  halfDaysLabel: 'அரை நாட்கள்',
  absentDaysLabel: 'விடுமுறை நாட்கள்',
  totalHmrLabel: 'மொத்த HMR',
  noActiveBookingIdle: 'செயலில் உள்ள முன்பதிவு இல்லை — இயந்திரம் செயலற்றது',
  siteLocationNotCaptured: 'தள இடம் பதிவு செய்யப்படவில்லை',
  siteLocationNotAvailable: 'தள இடம் கிடைக்கவில்லை',
  bookingRefLabel: 'முன்பதிவு Ref',
  alertPendingBookings: 'நிலுவையில் உள்ள முன்பதிவுகள்',
  alertPendingPayouts: 'நிலுவையில் உள்ள செலுத்துதல்கள்',
  alertLowFuel: 'குறைந்த எரிபொருள்',
  alertOpenIssues: 'திறந்த பிரச்சனைகள்',
  noMachineRunning: 'தற்போது எந்த இயந்திரமும் இயங்கவில்லை',
  trackingEmptyHint: 'இயந்திரம் அனுப்பப்பட்டவுடன் உங்கள் செயலில் உள்ள முன்பதிவு இங்கே தோன்றும்.',
  trackingUpdatedEvery5s: 'ஒவ்வொரு 5 வினாடிக்கும் புதுப்பிக்கப்படும்',
  fuelLastOperatorUpdate: '(கடைசி ஆபரேட்டர் புதுப்பிப்பு)',
  alertExtensionPending: 'முன்பதிவு நீட்டிப்பு நிலுவையில்',
  alertConfirmCompletion: 'வேலை முடிவை உறுதிப்படுத்தவும்',
  alertWalletCredited: 'வாலட்டில் சேர்க்கப்பட்டது',
  alertFeedbackRequest: 'வேலை முடிந்தது — உங்கள் கருத்தைப் பகிரவும்',
  noLogsYet: 'இன்னும் செயல்பாடு பதிவாகவில்லை',
  todayActivityLog: 'இன்றைய செயல்பாட்டு பதிவு',
  machineLogSubtitle: 'எரிபொருள், வருகை, சிக்கல்கள் — உள்ளூர் அமர்வு பதிவு',
  timerPaused: 'Timer இடைநிறுத்தப்பட்டது',
  liveBookingTitle: 'நேரடி முன்பதிவு',
  machineLogTimerHint: 'Timer Admin தொடங்குகிறார். கீழே உங்கள் உண்மையான வேலை நேரத்தை பதிவு செய்யுங்கள் — முடிந்ததும் Mark Work Complete ஐ கிளிக் செய்யுங்கள்.',
  resumeTimer: 'Resume Timer',
  pauseTimer: 'Pause Timer',
  attendanceLogNote: 'வருகை',
  ownerAlertBookingPending: 'புதிய முன்பதிவு உங்கள் அனுமதிக்காக நிலுவையில் —',
  ownerAlertBookingHours: 'மணிநேரம்',
  ownerAlertPayoutPending: '₹{{amount}} செலுத்துதல் பரிமாற்றத்திற்கு நிலுவையில்',
  ownerAlertFuelLow: 'எரிபொருள் குறைவு',
  ownerAlertFuelRemaining: 'மீதம்',
  ownerAlertIssue: 'சிக்கல் பதிவு செய்யப்பட்டது',
  iotGpsDevicesActive: 'GPS சாதனங்கள் செயலில்',
  iotDashcamsOnline: 'டாஷ்கேம் ஆன்லைன்',
  iotFuelSensorsActive: 'எரிபொருள் சென்சார்கள் செயலில்',
  iotMachinesLocked: 'மெஷின்கள் பூட்டப்பட்டது',
  iotDeviceStatus: 'IoT சாதன நிலை',
  iotColMachine: 'மெஷின்',
  iotColGps: 'GPS',
  iotColLocation: 'இடம்',
  iotColFuel: 'எரிபொருள் %',
  iotColDashcam: 'டாஷ்கேம்',
  iotColIgnition: 'இக்னிஷன்',
  iotColAction: 'செயல்',
  iotStatusOnline: 'ஆன்லைன்',
  iotStatusNotConnected: 'இணைக்கப்படவில்லை',
  iotStatusLive: 'நேரலை',
  iotStatusOn: 'ON',
  iotStatusOff: 'OFF',
  iotLockBtn: 'பூட்டு',
  iotNotConnectedBanner: 'IoT வன்பொருள் இன்னும் நிறுவப்படவில்லை. Teltonika சாதனம் நிறுவிய பிறகு GPS, டாஷ்கேம் மற்றும் ரிமோட் லாக் வசதிகள் கிடைக்கும்.',
  fuelUpdateTitle: 'எரிபொருள் புதுப்பிப்பு',
  fuelSensorAccuracyNote: 'இயக்குநர் பதிவு செய்த எரிபொருள் அளவு · கைமுறை உள்ளீடு',
  bookingsTab: 'முன்பதிவுகள்',
  unknownLabel: 'தெரியாதது',
  naLabel: 'N/A',
  baseLabel: 'அடிப்படை',
  qtyLabel: 'அளவு',
  actualHrsLabel: 'உண்மையான மணிநேரம்',
  auditStatTotal: 'மொத்தம்',
  auditStatSecurity: 'பாதுகாப்பு',
  auditStatActors: 'செயலிகள்',
  auditStatAdmin: 'Admin',
  auditStatNonAdmin: 'Non-Admin',
  kycDocLicense: 'உரிமம்',
  kycDocAadhaarFront: 'Aadhaar முன்',
  kycDocAadhaarBack: 'Aadhaar பின்',
  kycDocPoliceVerification: 'போலீஸ் சரிபார்ப்பு',
  kycVerification: 'KYC சரிபார்ப்பு',
  kycNotSubmitted: 'KYC சமர்ப்பிக்கப்படவில்லை',
  kycUnderReview: 'KYC மதிப்பாய்வில்',
  kycVerified: 'KYC சரிபார்க்கப்பட்டது',
  kycRejected: 'KYC நிராகரிக்கப்பட்டது',
  kycAadhaarFront: 'Aadhaar முன்',
  kycAadhaarBack: 'Aadhaar பின்',
  kycSelfie: 'செல்ஃபி',
  kycSubmitBtn: 'KYC ஆவணங்களை சமர்ப்பிக்கவும்',
  kycSubmitSuccess: 'ஆவணங்கள் சமர்ப்பிக்கப்பட்டன — மதிப்பாய்வில்',
  kycResubmit: 'ஆவணங்களை மீண்டும் சமர்ப்பிக்கவும்',
  adminKycTitle: 'வாடிக்கையாளர் KYC மதிப்பாய்வு',
  adminKycAllFilter: 'அனைத்தும்',
  adminKycNoSubmissions: 'இன்னும் KYC சமர்ப்பிப்புகள் இல்லை',
  adminOwnerKycTitle: 'உரிமையாளர் KYC மதிப்பாய்வு',
  adminOwnerKycNoSubmissions: 'இன்னும் உரிமையாளர் KYC சமர்ப்பிப்புகள் இல்லை',
  adminOperatorKycTitle: 'ஆபரேட்டர் KYC மதிப்பாய்வு',
  adminOperatorKycNoSubmissions: 'இன்னும் ஆபரேட்டர் KYC சமர்ப்பிப்புகள் இல்லை',
  kycRejectedWarning: 'உங்கள் KYC நிராகரிக்கப்பட்டது. தயவுசெய்து ஆவணங்களை மீண்டும் சமர்ப்பிக்கவும்.',
  kycNotSubmittedHint: 'நம்பகமான அனுபவத்திற்கு KYC-ஐ முடிக்கவும்.',
  kycPendingHint: 'உங்கள் KYC மதிப்பாய்வில் உள்ளது.',
  kycGoToTab: 'KYC-க்கு செல்லுங்கள்',
  adminKycApproveBtn: 'அனுமதி',
  adminKycRejectBtn: 'நிராகரி',
  adminKycViewDocs: 'ஆவணங்களைக் காண்க',
  adminKycRejectReason: 'நிராகரிப்பு காரணம்',
  adminKycRereviewBtn: 'மீண்டும் மதிப்பாய்வு',
  kycPan: 'PAN அட்டை',
  kycOwnerSubmitSuccess: 'ஆவணங்கள் சமர்ப்பிக்கப்பட்டன — உங்கள் KYC மதிப்பாய்வில் உள்ளது',
  kycLicense: 'ஓட்டுநர் உரிமம்',
  kycPoliceVerification: 'போலீஸ் சரிபார்ப்பு',
  kycOperatorSubmitSuccess: 'ஆவணங்கள் சமர்ப்பிக்கப்பட்டன — உங்கள் KYC மதிப்பாய்வில் உள்ளது',
  operatorKycRejectedAssign: 'இந்த ஆபரேட்டரின் KYC நிராகரிக்கப்பட்டது — மீண்டும் அங்கீகரிக்கப்படும் வரை அவர்களை ஒதுக்க முடியாது.',
  operatorsColOperator: 'ஆபரேட்டர்',
  operatorsColEmail: 'மின்னஞ்சல்',
  operatorsColPhone: 'தொலைபேசி',
  operatorsColDocuments: 'ஆவணங்கள்',
  operatorsColStatus: 'நிலை',
  operatorsDocumentsBtn: 'ஆவணங்கள் ({{count}})',
  operatorsNoResults: 'ஆபரேட்டர்கள் இல்லை',
  operatorsAllTitle: 'அனைத்து ஆபரேட்டர்கள் ({{count}})',
  operatorsKycDialogDesc: 'KYC ஆவணங்கள்',
  bookingsCountLabel: '{{count}} புக்கிங்கள்',
  complianceDates: 'இணக்க தேதிகள்',
  complianceInsurance: 'காப்பீடு',
  complianceRcBook: 'RC புத்தகம்',
  compliancePuc: 'PUC',
  complianceNotSet: 'அமைக்கப்படவில்லை',
  complianceExpired: 'காலாவதியானது',
  complianceExpiringSoon: 'விரைவில் காலாவதி',
  complianceExpiringCritical: '7 நாட்களில் காலாவதி',
  complianceValid: 'செல்லுபடி',
  complianceUpdateBtn: 'இணக்க தேதிகளை புதுப்பிக்கவும்',
  complianceSaveBtn: 'சேமி',
  complianceAlertsTitle: 'இணக்க எச்சரிக்கைகள்',
  complianceAllCompliant: 'அனைத்து இயந்திரங்களும் இணக்கமாக உள்ளன ✅',
  complianceColMachine: 'இயந்திரம்',
  complianceColOwner: 'உரிமையாளர்',
  complianceColInsurance: 'காப்பீடு',
  complianceColRcBook: 'RC புத்தகம்',
  complianceColPuc: 'PUC',
  complianceNa: 'N/A',
  complianceStartDate: 'தொடக்க தேதி',
  complianceEndDate: 'முடிவு தேதி',
  complianceExtractBtn: 'தேதிகளை தானாக நிரப்ப ஆவணத்தை பதிவேற்றவும்',
  complianceExtractSuccess: 'தேதிகள் பிரித்தெடுக்கப்பட்டன — சேமிப்பதற்கு முன் சரிபார்க்கவும்',
  complianceExtractError: 'தேதிகளை பிரித்தெடுக்க முடியவில்லை — கைமுறையாக உள்ளிடவும்',
  complianceExtracting: 'ஆவணம் படிக்கப்படுகிறது...',
  serviceHistory: 'சேவை வரலாறு',
  serviceLastService: 'கடைசி சேவை',
  serviceNoRecords: 'இன்னும் சேவை பதிவுகள் இல்லை',
  serviceNextDue: 'அடுத்த சேவை கெடு',
  serviceNextHmr: 'அடுத்த சேவையில்',
  serviceAddLog: 'சேவை பதிவு சேர்',
  serviceDate: 'சேவை தேதி',
  serviceType: 'சேவை வகை',
  serviceHmr: 'சேவை HMR',
  serviceNextDate: 'அடுத்த சேவை தேதி',
  serviceWorkDone: 'செய்த வேலை',
  serviceNotes: 'குறிப்புகள்',
  serviceTypeRoutine: 'வழக்கமான',
  serviceTypeMajor: 'முக்கிய',
  serviceTypeBreakdown: 'பழுது',
  serviceTypePdi: 'PDI',
  serviceTypeOther: 'மற்ற',
  serviceOverdue: 'காலாவதி',
  serviceDueSoon: 'விரைவில் கெடு',
  fleetAnalytics: 'ஃப்ளீட் பகுப்பாய்வு',
  analyticsRevenue: 'மொத்த வருவாய்',
  analyticsBookings: 'மொத்த முன்பதிவுகள்',
  analyticsHours: 'மொத்த மணிநேரம்',
  analyticsActiveMachines: 'செயலில் உள்ள இயந்திரங்கள்',
  analyticsMonthlyTrend: 'மாதாந்திர வருவாய் போக்கு',
  analyticsMachineTable: 'இயந்திர வாரியான வருவாய்',
  analyticsNoData: 'இந்த காலத்தில் முடிக்கப்பட்ட முன்பதிவுகள் இல்லை',
  analyticsLastBooking: 'கடைசி முன்பதிவு',
  analytics3Months: '3 மாதம்',
  analytics6Months: '6 மாதம்',
  analytics12Months: '12 மாதம்',
  adminAnalytics: 'பகுப்பாய்வு',
  adminFleetTitle: 'ஃப்ளீட் பகுப்பாய்வு',
  adminFleetPlatformRevenue: 'தள வருவாய்',
  adminFleetActiveOwners: 'செயலில் உள்ள உரிமையாளர்கள்',
  adminFleetOwnerCol: 'உரிமையாளர்',
  adminFleetMonthlyTrend: 'மாதாந்திர வருவாய் போக்கு',
  adminFleetMachineTable: 'இயந்திர வாரியான வருவாய்',
  adminFleetNoData: 'இந்த காலத்தில் முடிக்கப்பட்ட முன்பதிவுகள் இல்லை',
  adminFinancialIntelligence: 'இயந்திர நிதி நுண்ணறிவு',
  adminTotalInvested: 'மொத்த முதலீடு',
  adminTotalEarned: 'மொத்த வருவாய்',
  adminAvgRecovery: 'சராசரி மீட்பு',
  adminBreakEvenRate: 'சமநிலை விகிதம்',
  adminProfitMargin: 'லாப வரம்பு',
  adminNoFinancialData: 'இன்னும் நிதி தரவு உள்ள இயந்திரங்கள் இல்லை',
  adminMachineDetail: 'இயந்திர விவரம்',
  adminCallOwner: 'உரிமையாளரை அழை',
  adminWhatsappOwner: 'WhatsApp உரிமையாளர்',
  adminMarketRates: 'சந்தை விகித சமர்ப்பிப்புகள்',
  adminMarketRateDelete: 'நீக்கு',
  adminMarketRateDeleteConfirm: 'இந்த சந்தை விகித சமர்ப்பிப்பை நீக்கவா?',
  adminMarketRateDeleted: 'சந்தை விகிதம் நீக்கப்பட்டது',
  adminMarketRateNoData: 'இன்னும் சந்தை விகித சமர்ப்பிப்புகள் இல்லை',
  marketRateApprove: 'அங்கீகரி',
  marketRateReject: 'நிராகரி',
  marketRateApproved: 'அங்கீகரிக்கப்பட்டது',
  marketRateRejected: 'நிராகரிக்கப்பட்டது',
  marketRatePending: 'நிலுவையில்',
  marketRateReviewed: 'சந்தை விகிதம் மதிப்பாய்வு செய்யப்பட்டது',
  marketRatePendingReview: 'உங்கள் விகிதம் சமர்ப்பிக்கப்பட்டது மற்றும் நிர்வாகி மதிப்பாய்வில் நிலுவையில் உள்ளது.',
  marketRateEditApprove: 'திருத்தி அங்கீகரி',
  marketRateEditMin: 'திருத்திய குறைந்தபட்ச விகிதம் (₹/மணி)',
  marketRateEditMax: 'திருத்திய அதிகபட்ச விகிதம் (₹/மணி)',
  adminPayrollOverview: 'சம்பள மேலோட்டம்',
  adminPayrollTotalOperators: 'மொத்த ஆபரேட்டர்கள்',
  adminPayrollTotalGross: 'மொத்த செலுத்த வேண்டியது',
  adminPayrollTotalNet: 'மொத்த நிகர செலுத்த வேண்டியது',
  adminPayrollNoData: 'இந்த மாதத்திற்கு சம்பள தரவு இல்லை',
  subTabSchedule: 'அட்டவணை',
  subTabHistory: 'வரலாறு',
  subTabAnalytics: 'பகுப்பாய்வு',
  clientAnalyticsTitle: 'முன்பதிவு பகுப்பாய்வு',
  clientAnalyticsSpend: 'மொத்த செலவு',
  clientAnalyticsHours: 'மொத்த மணிநேரம்',
  clientAnalyticsBookings: 'முடிக்கப்பட்ட முன்பதிவுகள்',
  clientAnalyticsMachines: 'பயன்படுத்திய இயந்திரங்கள்',
  clientAnalyticsAvgSpend: 'ஒரு முன்பதிவுக்கு சராசரி',
  clientAnalyticsMonthlyTrend: 'மாதாந்திர செலவு போக்கு',
  clientAnalyticsTopMachines: 'முதன்மை இயந்திரங்கள்',
  clientAnalyticsNoData: 'இந்த காலத்தில் முடிக்கப்பட்ட முன்பதிவுகள் இல்லை',
  operatorAnalyticsTitle: 'வேலை பகுப்பாய்வு',
  operatorAnalyticsPresentDays: 'வரும் நாட்கள்',
  operatorAnalyticsHalfDays: 'அரை நாள்',
  operatorAnalyticsHmr: 'மொத்த HMR',
  operatorAnalyticsJobs: 'முடிந்த வேலைகள்',
  operatorAnalyticsIssues: 'புகாரளிக்கப்பட்ட பிரச்சினைகள்',
  operatorAnalyticsAvgHmr: 'சராசரி HMR/நாள்',
  operatorAnalyticsMonthlyTrend: 'மாதாந்திர வேலை போக்கு',
  operatorAnalyticsIssueBreakdown: 'வகை வாரியாக பிரச்சினைகள்',
  operatorAnalyticsRecentJobs: 'சமீபத்திய வேலைகள்',
  operatorAnalyticsNoData: 'இந்த காலத்தில் வேலை பதிவுகள் இல்லை',
  adminServiceAlertsTitle: 'சேவை எச்சரிக்கைகள்',
  adminServiceAllOk: 'அனைத்து இயந்திரங்களின் சேவை பதிவுகளும் புதுப்பித்த நிலையில் உள்ளன ✅',
  adminServiceNoRecord: 'பதிவுகள் இல்லை',
  adminServiceColLastService: 'கடைசி சேவை',
  adminServiceColNextDue: 'அடுத்த காலக்கெடு',
  adminServiceColServiceStatus: 'சேவை நிலை',
  adminMachinesColMinHrs: 'குறைந்தபட்ச மணி',
  adminMachinesColRateDay: 'விகிதம்/நாள்',
  adminClientName: 'வாடிக்கையாளர் பெயர்',
  adminOwnerName: 'உரிமையாளர் பெயர்',
  adminPayoutWallet: 'பணம் செலுத்தும் பணப்பை',
  adminFooterMachines: 'இயந்திரங்கள்',
  adminFooterClients: 'வாடிக்கையாளர்கள்',
  adminFooterOwners: 'உரிமையாளர்கள்',
  auditSeverityCritical: 'முக்கியமான',
  auditSeverityHigh: 'உயர்',
  auditSeverityMedium: 'நடுத்தர',
  auditSeverityNormal: 'சாதாரண',
  auditCopyEvent: 'நிகழ்வை நகலெடு',
  auditViewDetails: 'விவரங்களைக் காண்',
  auditHideDetails: 'விவரங்களை மறை',
  auditCopyJson: 'JSON நகலெடு',
  auditNoLogs: 'ஆடிட் பதிவுகள் இல்லை',
  auditIntroBanner: 'உள்நுழைவு, நிர்வாக நடவடிக்கைகள் மற்றும் பாதுகாப்பு நிகழ்வுகள். வடிகட்டிகள் ஏற்றப்பட்ட முடிவுகளுக்கு பொருந்தும்; பழைய வரிசைகளுக்கு மேலும் ஏற்றவும்.',
  auditLoaded: 'ஏற்றப்பட்டது',
  auditMoreAvailable: 'மேலும் கிடைக்கிறது',
  auditEndOfList: 'பட்டியல் முடிவு',
  auditFilterActive: 'வடிகட்டி செயலில்',
  auditFiltersActive: 'வடிகட்டிகள் செயலில்',
  auditSeverityBreakdown: 'தீவிரத்தன்மை பிரிவு (தற்போதைய பட்டியல்)',
  auditPressSlash: 'நடவடிக்கை வடிகட்டியில் கவனம் செலுத்த / அழுத்தவும்',
  auditFilters: 'வடிகட்டிகள்',
  auditFilterActionPlaceholder: 'Filter action (e.g. dlq_retry)',
  auditFilterActorPlaceholder: 'Filter actorId',
  auditAllRoles: 'அனைத்து பாத்திரங்கள்',
  auditFilterEntityPlaceholder: 'Entity type (e.g. dead_letter_queue)',
  auditFilterMetaPlaceholder: 'மெட்டாடேட்டா JSON தேடவும்',
  auditFilterFromPlaceholder: 'தொடக்க தேதி மற்றும் நேரம்',
  auditFilterToPlaceholder: 'முடிவு தேதி மற்றும் நேரம்',
  audit24h: '24h',
  audit7d: '7d',
  auditTimezonePrefix: 'நேர மண்டலம்:',
  auditTimezoneSuffix: '(உள்ளூர்)',
  auditHideCsvOptions: 'CSV நெடுவரிசை விருப்பங்களை மறை',
  auditShowCsvOptions: 'CSV நெடுவரிசை விருப்பங்களை காட்டு',
  auditCsvColCreatedAt: 'உருவாக்க நேரம்',
  auditCsvColAction: 'நடவடிக்கை',
  auditCsvColActorId: 'Actor ID',
  auditCsvColActorRole: 'Actor Role',
  auditCsvColEntityType: 'Entity Type',
  auditCsvColEntityId: 'Entity ID',
  auditCsvColMetadata: 'மெட்டாடேட்டா',
  auditFooterLoaded: 'ஏற்றப்பட்டது',
  auditFooterLogs: 'தணிக்கை பதிவுகள்',
  auditFooterMoreAvailable: '(மேலும் கிடைக்கிறது)',
  auditFooterAllLoaded: '(அனைத்தும் ஏற்றப்பட்டது)',
  auditActor: 'நடிகர்',
  auditEntity: 'நிறுவனம்',
  auditEventLog: 'நிகழ்வு பதிவு',
  notificationCenter: 'அறிவிப்புகள்',
  notifChannelAll: 'அனைத்தும்',
  notifChannelWhatsapp: 'WhatsApp',
  notifChannelEmail: 'மின்னஞ்சல்',
  notifChannelPush: 'புஷ்',
  notifChannelSms: 'SMS',
  notifStatusSent: 'அனுப்பப்பட்டது',
  notifStatusFailed: 'தோல்வி',
  notifStatusPending: 'நிலுவை',
  notifEmpty: 'இன்னும் அறிவிப்புகள் இல்லை',
  notifLoadMore: 'மேலும் ஏற்று',
  adminNotifLog: 'அறிவிப்பு பதிவு',
  adminNotifColUser: 'பயனர்',
  adminNotifColRole: 'பாத்திரம்',
  adminNotifNoData: 'இன்னும் அறிவிப்புகள் பதிவு செய்யப்படவில்லை',
  etaOwnerApproval: 'உரிமையாளர் அனுமதிக்காக காத்திருக்கிறது',
  etaWorkInProgress: 'மதிப்பிடப்பட்ட முடிவு',
  etaPaymentDeadline: 'பணம் உறுதிப்படுத்தல் காலக்கெடு',
  etaWorkCompleted: 'வேலை முடிந்தது',
  etaDisputeReview: 'DE குழு விவாதத்தை மதிப்பாய்வு செய்கிறது',
  etaMinutesRemaining: '{n} நிமிடங்கள் மீதம்',
  etaHoursRemaining: '{n} மணி நேரம் மீதம்',
  txRecharge: 'வாலட் ரீசார்ஜ்',
  txBookingAdvance: 'புக்கிங் முன்பணம்',
  txBookingPayment: 'புக்கிங் கட்டணம்',
  txSettlement: 'செட்டில்மென்ட்',
  txRefund: 'பணத்திருப்பம்',
  txPenalty: 'அபராதம்',
  txCommission: 'கமிஷன்',
  tacTitle: "விதிமுறைகள் & நிபந்தனைகள்",
  tacPrivacy: "தனியுரிமைக் கொள்கை",
  tacRefund: "பணத்திருப்பக் கொள்கை",
  tacCancellation: "ரத்துக் கொள்கை",
  tacServiceDelivery: "சேவை வழங்கல் கொள்கை",
  tacIntro: "முன்பதிவுக்கு முன் எங்கள் கொள்கைகளைப் பார்க்கவும்",
  tacBannerTitle: "விதிமுறைகள் புதுப்பிப்பு உள்ளது",
  tacBannerOpen: "விதிமுறைகளைத் திறக்கவும்",
  tacBannerAgree: "நான் படித்து ஒப்புக்கொள்கிறேன்",
  tacBannerLater: "பின்னர்",
  clientPoliciesTitle: "வாடிக்கையாளர் கொள்கைகள்",
  machineGroupAvailable: "கிடைக்கும்",
  machineGroupBusy: "பணியில்",
  dewateringReferral: "டிவாட்டரிங் (பம்ப்) சேவை வேண்டுமா? MachineOS விரைவில் பம்ப் ஒப்பந்ததாரர் சேவைகளைச் சேர்க்கும். பரிந்துரைக்கு சப்போர்ட்டைத் தொடர்பு கொள்ளவும்.",
  noActiveWork: "இந்த மாதம் செயலில் வேலை இல்லை",
  accountTab: "கணக்கு",
  recentActivity: "சமீபத்திய செயல்பாடு",
  goodMorning: "காலை வணக்கம்",
  goodAfternoon: "மதிய வணக்கம்",
  goodEvening: "மாலை வணக்கம்",
  thisMonthEarned: 'This month earned',
  standardBookings: 'Standard bookings',
  activeContracts: 'Active contracts',
  contractsOngoing: 'Contracts ongoing',
  noActiveContracts: 'None this period',
  quotationsPending: 'Quotations awaiting reply',
  allUpToDate: 'All bookings up to date',
  noBookingsInPeriod: 'No bookings in this period',
  contractBookings: 'Contract bookings',
  noContractsInPeriod: 'No contracts in this period',
  mobilizationReleased: 'Mobilization released',
  pendingRelease: 'Pending release',
  raBills: 'RA-bills',
  disputed: 'Disputed',
  all: 'All',
  completed: 'Completed',
};
